var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card", staticStyle: { width: "100%" } }, [
      _c("div", { staticClass: "card-content" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", {
            staticClass: "font-large-2",
            domProps: { textContent: _vm._s(_vm.job.title) },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "border-bottom" }, [
            _c("div", {}, [
              _c("p", { staticClass: "primary font-medium-3 mb-05" }, [
                _c("i", { staticClass: "fa fa-briefcase" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.job.employment_type) +
                    "\n                        "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: " font-small-3 text-muted" }, [
                _c("i", { staticClass: "fa fa-map-marker" }),
                _vm._v(" " + _vm._s(_vm.job.position_location)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pt-1 pb-1 border-bottom breakAll" }, [
              _c("span", {
                staticClass: "breakAll image-resize",
                domProps: { innerHTML: _vm._s(_vm.job.position_description) },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pt-1 pb-1 border-bottom" }, [
              _c("strong", [
                _vm._v(
                  " " + _vm._s(_vm.__("job.field.label.position_salary")) + ":"
                ),
              ]),
              _vm._v(
                " " + _vm._s(_vm.job.position_salary) + "\n                    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-center border-bottom pt-1 pb-1",
              },
              [
                _c("div", [
                  _c("div", { staticClass: "pb-1" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.__("job.company_name")) + ":"),
                    ]),
                    _c("br"),
                    _vm._v(" " + _vm._s(_vm.job.organisation_name)),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.__("job.company_description")) + ":"),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "breakAll",
                      domProps: {
                        innerHTML: _vm._s(_vm.job.organisation_description),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pt-1" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.__("job.company_size")) + ":"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.job.organisation_size)),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex mt-1" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-primary waves-effect waves-light form-control",
                  attrs: {
                    "data-toggle": "modal",
                    "data-target": "#registerModal",
                  },
                },
                [_vm._v(_vm._s(_vm.__("job.form.links.apply_for_position")))]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-between border-top pl-05 pr-05",
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "p-05" }, [
              _c(
                "span",
                {
                  attrs: {
                    "data-toggle": "modal",
                    "data-target": "#registerModal",
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-comment-o" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.__("globals.comment")) +
                      "\n                    "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "p-05" }, [
              _c("div", { staticClass: "dropdown" }, [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-toggle",
                    attrs: {
                      id: "socialShareButton",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false",
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-share-alt" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.__("globals.share")) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-menu",
                    attrs: { "aria-labelledby": "socialShareButton" },
                  },
                  [_c("span", { domProps: { innerHTML: _vm._s(_vm.social) } })]
                ),
              ]),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "p-05" }, [
      _c("i", {
        staticClass: "fa fa-thumbs-o-up",
        attrs: { "data-toggle": "modal", "data-target": "#registerModal" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }